import { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import apiClient from '../utils/api';

// Start a provider's OAuth connection from anywhere (Me, /start). The backend
// returns the authorize URL; we only follow it when its host is one we expect,
// so a misbehaving response can never bounce the person to an arbitrary site.
// Fitbit still lives on its legacy route; the others share the device layer.

const ALLOWED_HOSTS = {
  fitbit: ['www.fitbit.com', 'accounts.fitbit.com'],
  oura: ['cloud.ouraring.com'],
  withings: ['account.withings.com'],
  whoop: ['api.prod.whoop.com'],
};

const connectUrl = (provider) =>
  provider === 'fitbit' ? '/api/auth/fitbit/connect' : `/api/auth/device/${provider}/connect`;

export const useDeviceConnect = () => {
  const [busy, setBusy] = useState(null);

  const connect = useCallback(async (provider) => {
    setBusy(provider);
    try {
      const res = await apiClient.get(connectUrl(provider));
      const redirectUrl = res.data?.redirect_url;
      let host = null;
      try {
        host = new URL(redirectUrl).hostname;
      } catch {
        host = null;
      }
      if (!host || !(ALLOWED_HOSTS[provider] || []).includes(host)) {
        toast.error('Invalid redirect URL received from server');
        return;
      }
      window.location.href = redirectUrl;
    } catch (error) {
      toast.error(error.response?.data?.detail || `Couldn't start the ${provider} connection just now.`);
    } finally {
      setBusy(null);
    }
  }, []);

  return { connect, busy };
};

export default useDeviceConnect;
